import { useTranslation } from 'react-i18next';
import { Badge, Tabs } from 'antd';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';
import InboxPanel from './InboxPanel';
import RecipientsTable from './RecipientsTable';
import TemplatePanel from './TemplatePanel';

/** The request's tabs; a list's page and filters mean nothing on another tab. */
export default function RequestTabs({ companyId, request, canWrite, onChanged }) {
  const { t } = useTranslation('partnerRequests');
  const { setQueryParams } = useQueryParamsContext();
  const shared = { companyId, request, canWrite, onChanged };

  return (
    <Tabs
      destroyInactiveTabPane
      onChange={() => setQueryParams({ offset: 1, unmatched: undefined })}
      items={[
        { key: 'recipients', label: t('tabs.recipients'), children: <RecipientsTable {...shared} /> },
        { key: 'text', label: t('tabs.text'), children: <TemplatePanel {...shared} /> },
        {
          key: 'inbox',
          label: (
            <Badge count={request.counts.unmatched} size="small" offset={[8, -2]}>
              {t('tabs.inbox')}
            </Badge>
          ),
          children: <InboxPanel {...shared} />,
        },
      ]}
    />
  );
}
